import * as api from '../api/benefits';

// Actions Creators
export const getBenefits = () => async (dispatch) => {
    try {
        const { data } = await api.fetchBenefits();
        
        dispatch({ type: 'FETCH_ALL_BENEFIT', payload: data });
        
    } catch (error) {
        console.log(error)
    }
}
    
export const createBenefits = (benefit) => async (dispatch) => {

    try {
        const { data } = await api.createBenefits(benefit);

        dispatch({ type: 'CREATE_BENEFIT', payload: data });

    } catch (error) {
        console.log(error)
    }
}

export const deleteBenefit = (id) => async (dispatch) => {
    try {
        await api.deleteBenefit(id);

        dispatch({ type: 'DELETE_BENEFIT', payload: id });

    } catch (error) {
        console.log(error)
    }
}
